// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '35ff81c',
    builtAt: '2026-10-01T12:04:55.952Z',
} as const;
